export const getConsents = (
    locale: string,
    localeRequiresMarketingCommunicationOptIn?: boolean
) => {
    //TO DO: Get signup to remove this payload reqirement as this is NOT shown to the user
    const consent = {
        site: "atlassian",
        locale: locale,
        formUrl: window.location.href,
        consents: [
            {
                key: "termsOfService",
                // showing "" as we do not show anything to the user
                displayedText: "",
                granted: true
            },
            {
                key: "privacyPolicy",
                // showing "" as we do not show anything to the user
                displayedText: "",
                granted: true
            },
            {
                key: "generalMarketingOptIn",
                // showing "" as we do not show anything to the user
                displayedText: "",
                granted: false
            }
        ]
    };

    if (localeRequiresMarketingCommunicationOptIn) {
        return consent.consents.map((i) => {
            if (i.key === "privacyPolicy") {
                return {
                    ...consent,
                    consents: { ...i, granted: false }
                };
            } else {
                return { ...consent, consents: i };
            }
        });
    } else {
        return {
            ...consent,
            consents: consent.consents.map((i) => ({ ...i, granted: true }))
        };
    }
};
